<template>
  <v-dialog v-model="openMode" max-width="600px" persistent>
    <v-card class="dialog-card">
      <v-card-title class="dialog-header" :class="formTitle === 'ערוך חבילה' ? 'edit-header' : 'create-header'">
        <span class="dialog-title">{{ formTitle }}</span>
        <v-btn icon dark @click="openMode = false" class="close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="dialog-content">
        <v-form @submit.prevent="submitHandler" ref="form">
          <div class="form-section">
            <h3 class="section-title">פרטים בסיסיים</h3>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="itemEdited.name" outlined dense label="שם חבילה"
                  :rules="[v => !!v || 'שדה חובה']" required prepend-inner-icon="mdi-tag"
                  class="form-field"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="itemEdited.price" outlined dense label="מחיר" type="number" hide-spin-buttons
                  :rules="priceRules" required prepend-inner-icon="mdi-currency-ils"
                  :disabled="isFreeType(itemEdited.bill_type)" class="form-field"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select v-model="itemEdited.bill_type" :items="billTypeOptions" item-text="text" item-value="value"
                  outlined dense label="סוג חיוב" :rules="[v => !!v || 'שדה חובה']" required
                  prepend-inner-icon="mdi-credit-card" @change="onBillTypeChange" class="form-field"></v-select>
                <div v-if="isFreeType(itemEdited.bill_type)" class="ravkol-info">
                  <v-alert type="info" dense outlined class="mt-2">
                    <v-icon slot="prepend">mdi-information</v-icon>
                    בחבילה חינמית, המחיר חייב להיות 0
                  </v-alert>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select v-model="agentValue" :items="agentOptions" item-text="text" item-value="value"
                  outlined dense label="שייכות" prepend-inner-icon="mdi-account-tie" class="form-field"
                  hint="חבילה של סוכן מוצגת בבחירת חבילה רק למערכות של אותו סוכן. מערכות שכבר בחבילה נשארות בה"
                  persistent-hint></v-select>
              </v-col>
            </v-row>
          </div>

          <div class="form-section">
            <h3 class="section-title">מאפייני חבילה</h3>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="itemEdited.channels" outlined dense label="ערוצים" type="number"
                  hide-spin-buttons :rules="[v => !!v || 'שדה חובה']" required prepend-inner-icon="mdi-broadcast"
                  class="form-field"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="itemEdited.contacts" outlined dense label="אנשי קשר" type="number"
                  hide-spin-buttons :rules="[v => !!v || 'שדה חובה']" required prepend-inner-icon="mdi-account-group"
                  class="form-field"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field v-model="itemEdited.storage" outlined dense label="גי'גה אחסון" type="number"
                  hide-spin-buttons :rules="[v => !!v || 'שדה חובה']" required prepend-inner-icon="mdi-database"
                  class="form-field"></v-text-field>
              </v-col>
            </v-row>
          </div>

          <div class="form-section">
            <h3 class="section-title">פרסומות ועוזר קולי</h3>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select v-model="itemEdited.features.ads" :items="adsOptions" item-text="text" item-value="value"
                  outlined dense label="פרסומות" prepend-inner-icon="mdi-bullhorn-outline" class="form-field"
                  hint="מנויי רב קול אף פעם לא שומעים פרסומות" persistent-hint></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select v-model="itemEdited.features.ai_access" :items="aiOptions" item-text="text" item-value="value"
                  outlined dense label="העוזר הקולי" prepend-inner-icon="mdi-robot-outline" class="form-field"
                  hint="בכפוף להרשאות של המערכת ולהגדרה של בעל המערכת" persistent-hint></v-select>
              </v-col>
            </v-row>
            <!-- רק ברב קול וניסיון: חבילות בתשלום ממילא לא נמחקות -->
            <v-row v-if="isFreeType(itemEdited.bill_type) || itemEdited.bill_type === 'trial'">
              <v-col cols="12">
                <v-switch v-model="itemEdited.features.delete_unused" color="primary" class="visibility-switch mt-0"
                  :label="`מחיקת מערכות לא פעילות אחרי 60 יום: ${itemEdited.features.delete_unused ? 'כן' : 'לא'}`"
                  hint="כבוי: מערכות בחבילה הזו לא יימחקו, גם אם לא נעשה בהן שימוש" persistent-hint></v-switch>
              </v-col>
            </v-row>
          </div>

          <div class="form-section">
            <h3 class="section-title">הגדרות נוספות</h3>
            <v-row>
              <v-col cols="12">
                <v-switch v-model="itemEdited.show_to_user" color="primary"
                  :label="`הצג למשתמשים: ${itemEdited.show_to_user ? 'כן' : 'לא'}`" class="visibility-switch"
                  hide-details></v-switch>
              </v-col>
              <v-col cols="12"
                v-if="itemEdited.price != null && itemEdited.price == 0 && !isFreeType(itemEdited.bill_type)">
                <v-switch v-model="itemEdited.is_trial" color="primary"
                  :label="`חבילת ניסיון: ${itemEdited.is_trial ? 'כן' : 'לא'}`" class="visibility-switch"
                  hide-details></v-switch>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="dialog-actions">
        <v-btn text @click="openMode = false" class="cancel-btn" :disabled="progressShow">
          ביטול
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="formTitle === 'ערוך חבילה' ? saveEditedPlan() : saveNewPlan()" class="save-btn"
          :loading="progressShow" :disabled="progressShow">
          <v-icon left>{{ formTitle === 'ערוך חבילה' ? 'mdi-content-save' : 'mdi-plus-circle' }}</v-icon>
          {{ formTitle === 'ערוך חבילה' ? 'שמור שינויים' : 'צור חבילה' }}
        </v-btn>
      </v-card-actions>

      <!-- Loading Indicator -->
      <v-overlay :value="progressShow" v-if="progressShow" absolute class="loading-overlay">
        <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
      </v-overlay>
    </v-card>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
  props: {
    planToEdit: Object,
    formTitle: String,
    value: { type: Boolean, default: false },
    agents: { type: Array, default: () => [] }, // [{ line_number, name }] - לשדה "שייכות"
  },
  components: {
    SnackBar,
  },
  data: () => ({
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
    itemEdited: {
      name: "",
      channels: "",
      storage: "",
      contacts: "",
      price: "",
      show_to_user: false,
      is_trial: false,
      bill_type: "",
      belong_to_agent: "",
      features: { ads: 'none', ai_access: 'all', delete_unused: false },
    },
    adsOptions: [
      { text: 'למי שאינו מנוי רב קול', value: 'non_members' },
      { text: 'לאף אחד', value: 'none' },
    ],
    aiOptions: [
      { text: 'לכל המתקשרים', value: 'all' },
      { text: 'רק למנויי רב קול', value: 'members' },
    ],
    billTypeOptions: [
      { text: 'הו"ק', value: "postpaid" },
      // חד פעמי: מוצג אפור ולא ניתן לבחירה - עדיין אין קרון לסוף התקופה, ותשלום יוצר הוראת קבע
      { text: "חד פעמי", value: "prepaid", disabled: true },
      { text: "חינמית", value: "free" },
      { text: "ניסיון", value: "trial" }
    ]
  }),
  // computed אחד בלבד: בעבר היו שניים, והשני דרס את הראשון - ולכן priceRules לא פעל אף פעם
  computed: {
    openMode: {
      get() {
        return this.value;
      },
      set(v) {
        return this.$emit('input', v);
      }
    },
    // שייכות לסוכן. v-select של Vuetify לא מציג אפשרות שהערך שלה מחרוזת ריקה - ולכן בשדה עצמו
    // חבילה כללית היא 'general', ובמסד היא נשארת '' (בלי שינוי בשרת)
    agentValue: {
      get() { return this.itemEdited.belong_to_agent || 'general'; },
      set(v) { this.itemEdited.belong_to_agent = v === 'general' ? '' : v; },
    },
    // שייכות: כללית, או אחד הסוכנים. סוכן שכבר לא קיים - נשאר ברשימה כדי שהערך הנוכחי יוצג
    agentOptions() {
      const list = [{ text: 'כללית (לכל המערכות שלא שייכות לסוכן)', value: 'general' },
        ...this.agents.map(a => ({ text: `${a.name} (${a.line_number})`, value: a.line_number }))];
      const current = this.itemEdited.belong_to_agent;
      if (current && !this.agents.some(a => a.line_number === current)) list.push({ text: `${current} (לא נמצא כסוכן)`, value: current });
      return list;
    },
    priceRules() {
      const rules = [v => v !== null && v !== undefined && v !== '' || 'שדה חובה'];

      if (this.isFreeType(this.itemEdited.bill_type)) {
        rules.push(v => v == 0 || 'בחבילה חינמית המחיר חייב להיות 0');
      }

      return rules;
    }
  },
  methods: {
    // החבילה החינמית. 'ravkol' - השם הישן, לתקופת המעבר (כמו FREE_BILL_TYPES בשרת)
    isFreeType(billType) {
      return billType === 'free' || billType === 'ravkol';
    },
    // ברירת המחדל לפי סוג החיוב - כמו src/util/planFeatures.js בשרת
    defaultFeaturesOf(billType) {
      if (this.isFreeType(billType)) return { ads: 'non_members', ai_access: 'members', delete_unused: true };
      if (billType === 'postpaid' || billType === 'prepaid') return { ads: 'none', ai_access: 'all', delete_unused: false };
      return { ads: 'none', ai_access: 'members', delete_unused: true }; // ניסיון
    },
    onBillTypeChange(value) {
      this.itemEdited.features = this.defaultFeaturesOf(value);
      if (this.isFreeType(value)) {
        // When selecting Rav-Kol bill type, set price to 0
        this.itemEdited.price = 0;
        // Also disable trial mode since it's for Rav-Kol
        this.itemEdited.is_trial = false;
      }
    },

    async saveNewPlan() {
      if (this.$refs.form.validate()) {
        try {
          this.progressShow = true;
          const ivrJSON = JSON.stringify({ plan: this.itemEdited });
          let token = localStorage.getItem("token");
          let api = process.env.VUE_APP_BASE_URL + "/admin_api/create_plan";

          const res = await fetch(api, ApiServices.requestOptions("POST", ivrJSON, token));
          const jsonObject = await res.json();

          if (res.status >= 400) {
            this.showSnackBar("Error: " + jsonObject, "red");
          } else if (res.status === 200) {
            this.$emit("planCreated", this.itemEdited, "החבילה נוצרה בהצלחה", "green");
            this.openMode = false;
          }
        } catch (error) {
          this.showSnackBar("Error saved new plan: " + error, "red");
        } finally {
          this.progressShow = false;
        }
      }
    },

    async saveEditedPlan() {
      if (this.$refs.form.validate()) {
        try {
          this.progressShow = true;
          const ivrJSON = JSON.stringify({ plan: this.itemEdited });
          let token = localStorage.getItem("token");
          let api = process.env.VUE_APP_BASE_URL + "/admin_api/edit_plan";

          const res = await fetch(api, ApiServices.requestOptions("PUT", ivrJSON, token));
          const jsonObject = await res.json();

          if (res.status >= 400) {
            this.showSnackBar("Error: " + jsonObject, "red");
          } else if (res.status === 200) {
            this.$emit("planEdited", this.itemEdited, "החבילה עודכנה בהצלחה", "green");
            this.openMode = false;
          }
        } catch (error) {
          this.showSnackBar("Error saved edited plan: " + error, "red");
        } finally {
          this.progressShow = false;
        }
      }
    },

    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true;
    },
  },
  mounted() {
    if (this.formTitle === "ערוך חבילה") {
      const plan = JSON.parse(JSON.stringify(this.planToEdit));
      // חבילה בשם הישן: מוצגת ונשמרת כ'free'
      if (plan.bill_type === 'ravkol') plan.bill_type = 'free';
      plan.belong_to_agent = plan.belong_to_agent || ''; // לפני ההשמה - כדי שיהיה ריאקטיבי
      // חבילה ישנה בלי תכונות: מציגים את מה שהיא עושה היום (לפי סוג החיוב).
      // features נבנה לפני ההשמה ל-itemEdited - שדה שמתווסף אחר כך לא ריאקטיבי ב-Vue 2
      plan.features = { ...this.defaultFeaturesOf(plan.bill_type), ...(plan.features || {}) };
      this.itemEdited = plan;
    } else {
      // Set default values for new plan
      this.itemEdited = {
        name: "",
        channels: "",
        storage: "",
        contacts: "",
        price: "",
        show_to_user: true,
        is_trial: false,
        bill_type: "",
        belong_to_agent: "",
        features: { ads: 'none', ai_access: 'all', delete_unused: false },
      };
    }
  },
}
</script>

<style scoped>
.dialog-card {
  border-radius: 12px;
  overflow: hidden;
  direction: rtl;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  color: white;
}

.create-header {
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
}

.edit-header {
  background: linear-gradient(135deg, #fdbd29 0%, #ffcf5c 100%);
  color: #0d2c6d;
}

.dialog-title {
  font-size: 1.4rem;
  font-weight: 600;
}

.close-btn {
  margin-right: -8px;
}

.dialog-content {
  padding: 24px;
}

.form-section {}

.form-section:last-child {
  margin-bottom: 0;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.form-field {}

.visibility-switch {
  margin-top: 8px;
}

.ravkol-info {
  margin-top: 8px;
}

.dialog-actions {
  padding: 16px 24px;
  background-color: #f8f9fa;
}

.save-btn {
  background: linear-gradient(0deg, rgba(255, 185, 26, 1) 0%, rgba(255, 185, 26, 0.8) 100%);
  color: #0d2c6d !important;
  font-weight: 600;
  border-radius: 8px;
  padding: 0 20px;
  height: 44px;
}

.cancel-btn {
  color: #666;
}

.loading-overlay {
  z-index: 999;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
}

@media (max-width: 600px) {
  .dialog-header {
    padding: 16px 20px;
  }

  .dialog-title {
    font-size: 1.2rem;
  }

  .dialog-content {
    padding: 16px;
  }

  .dialog-actions {
    padding: 12px 16px;
  }
}
</style>